import _ from 'lodash';
import helpers from '../helpers.js';
import $ from 'jquery';

let translations = null;
const regexes = {
  email: new RegExp(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/),
};

function validateEmailWithServer(value) {
  let errMsg = null;
  $.ajaxSetup({ async: false, timeout: 200 });
  $.get(`${_.get(globals, 'apiWebroot', '/')}auth/validate_email`, { email: value }, (resp) => {
    if (resp.status == 'ok' && resp.errors) {
      errMsg = _.values(resp.errors).pop();
    }
  });
  return errMsg;
}

const rules = {
  email(value) {
    if (!regexes.email.test(value)) {
      return _.get(translations, 'email.email', null);
    }
    return null;
  },
  email_server(value) {
    const errMsg = validateEmailWithServer(value);
    if (errMsg) {
      return errMsg;
    }
    return null;
  },
  email_check(value, value2) {
    if (!regexes.email.test(value)) {
      return _.get(translations, 'email_check.email', null);
    }
    if (value != value2) {
      return _.get(translations, 'email_check.matches', null);
    }
    return null;
  },
  agree(value) {
    if (value == 0) {
      return _.get(translations, 'agree.notEmpty');
    }

    return null;
  },
  properties: {
    phone(value) {
      if (value.replace(' ', '') == '' || isNaN(value)) {
        return _.get(translations, 'properties.phone.notEmpty', null);
      }
      return null;
    },
    no_spam(value) {
      if (value === null) {
        return _.get(translations, 'properties.no_spam', null);
      }

      return null;
    },
    agree_to_privacy_policy(value) {
      if (value != 1) {
        return _.get(translations, 'properties.agreed_to_privacy_policy', null);
      }

      return null;
    }
  },
  profile: {
    birth: {
      day(value) {
        if (parseInt(value) < 1) {
          return ' ';
        }
        return null;
      },
      month(value) {
        if (parseInt(value) < 1) {
          return ' ';
        }
        return null;
      },
      year(value) {
        if (value == 0 || (new Date().getFullYear() - parseInt(value)) < 18) {
          return _.get(translations, 'profile.age.inRange', null);
        }

        return null;
      },
    },
    name(value) {
      if (value.length < 2 || value.length > 30) {
        return _.get(translations, 'profile.name.lengthBetween', null);
      }
      if (/\d/.test(value)) {
        return _.get(translations, 'profile.name.noDigits');
      }
      return null;
    },
    sex(value) {
      if (['M', 'F'].indexOf(value) == -1) {
        return _.get(translations, 'profile.sex.inList', null);
      }
      return null;
    },
  },
  password(value) {
    if (value.length < 7) {
      return _.get(translations, 'password.lengthBetween', null);
    }

    return null;
  },
  password_check(value, value2) {
    if (value.length < 7) {
      return _.get(translations, 'password.lengthBetween', null);
    }
    if (value != value2) {
      return _.get(translations, 'password_check.matches', null);
    }

    return null;
  },
  'g-recaptcha-response': function (value) {
    if (value == '') {
      return _.get(translations, 'g-recaptcha-response.validRecaptcha', null);
    }

    return null;
  },
};

function initTranslations(val) {
  translations = val;
}

function checkData(data, excluded) {
  let errors = {};
  if (typeof excluded === 'undefined') {
    excluded = [];
  }
  helpers.iterateThroughObject(data, (value, key, aggrKey) => {
    if (excluded.indexOf(aggrKey) !== -1) {
      return;
    }
    const rule = _.get(rules, aggrKey);
    if (typeof rule === 'function') {
      let value2 = null;
      if (aggrKey == 'password_check') {
        value2 = data.password;
      }
      if (aggrKey == 'email_check') {
        value2 = data.email;
      }
      errors = _.set(errors, aggrKey, rule(value, value2));
    }
  });
  return errors;
}

module.exports = {
  rules,
  initTranslations,
  checkData,
};
